import Settings from "./settings";
const instance = Settings.createInstance();

// @ts-ignore
instance.createInstance = Settings.createInstance;

export default instance;